export default {
  checkout: 'checkout-v2',
  checkoutRegistration: 'registration',
  checkoutShipping: 'shipping',
  checkoutPayment: 'payment',
  pageNotFound: 'page-not-found',
  product: 'products-v2',
  demo: 'demo',
  demoForm: 'demo-form',
}
